import React from 'react';
import { Grid } from '@material-ui/core';
import BrandCompanyDetails from '../BrandCompanyDetails';

import { BrandDetail } from '../../types';
import BrandContactDetails from '../BrandContactDetails';
import BrandRelationshipDetails from '../BrandRelationshipDetails';

import { Box, RoleGuard } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuildingCircleCheck,
  faPen,
  faUserCircle,
  faChartNetwork,
} from '@fortawesome/pro-regular-svg-icons';
import BusinessContactDetails from '../BusinessContactDetails/BusinessContactDetails';
import { isBusinessContactEmailVisible } from '../../utils';

interface Props {
  brand: BrandDetail;
  handleEditClick: (_type: string) => void;
  actionGuard?: (func: (...args: any[]) => any) => any;
}
const BrandCompanyContactBlock: React.FC<Props> = ({
  brand,
  handleEditClick,
  actionGuard = (func: (...args: any[]) => any) =>
    (...args: any[]) =>
      func(...args),
}) => {
  return (
    <Grid item xs={12} data-testid="brandCompanyContactBlock">
      <div className="company details">
        <div className="details-heading">
          <div className="title">
            <Box
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              <Box margin={{ right: 'xs' }}>
                <FontAwesomeIcon icon={faBuildingCircleCheck} size="xl" />
              </Box>
              <h3 className="heading1">Company Details</h3>
            </Box>
          </div>
          <RoleGuard feature="brandDetail.editCompanyDetails">
            <React.Fragment>
              <div
                className="edit-btn"
                onClick={actionGuard(() => handleEditClick('company'))}
                data-testid="brandCompanyContactBlockEditCompanyButton"
              >
                <Box
                  flexDirection="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box margin={{ right: 'xs' }}>
                    <FontAwesomeIcon icon={faPen} color="#0091B3" />
                  </Box>
                  <span>Edit</span>
                </Box>
              </div>
            </React.Fragment>
          </RoleGuard>
        </div>
        <BrandCompanyDetails brand={brand} />

        <div className="details-heading contact-details">
          <div className="title">
            <Box
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              <Box margin={{ right: 'xs' }}>
                <FontAwesomeIcon icon={faUserCircle} size="xl" />
              </Box>
              <h3 className="heading1">Support Contact Details</h3>
            </Box>
          </div>
        </div>
        <BrandContactDetails brand={brand} />

        <div className="details-heading contact-details">
          <div className="title">
            <Box
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              <Box margin={{ right: 'xs' }}>
                <FontAwesomeIcon icon={faChartNetwork} size="xl" />
              </Box>
              <h3 className="heading1">Brand Relationship</h3>
            </Box>
          </div>
        </div>
        <BrandRelationshipDetails brand={brand} />

        {isBusinessContactEmailVisible(brand.entityType) && (
          <BusinessContactDetails brand={brand} />
        )}
      </div>
    </Grid>
  );
};

export default BrandCompanyContactBlock;
